import React, { useState, useRef, useContext } from "react";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { ChangePasswordValidate } from "../../config/Validate";
import { Link, useNavigate } from "react-router-dom";
import { Buffer } from "buffer";
import { updateData } from "../../service/ApiService";
import { CHANGE_PASSWORD } from "../../config/ApiConstant";

const ChangePassword: React.FC = () => {
  const navigate = useNavigate();

  // get userdata from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  // parse rawuserdata into userData
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  // logout functionality
  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  // tost ref
  const toast = useRef<any>(null);

  // password obj
  const [passwords, setPasswords] = useState<any>({});

  // error obj
  const [errors, setErrors] = useState<any>({});

  // loading
  const [loading, setLoading] = useState(false);

  //onChange Input
  const onInputChange = (e: any, name: string) => {
    const val = (e.target && e.target.value) || "";
    setPasswords({ ...passwords, [name]: val });
  };

  // submit api call
  const handleSubmit = async () => {
    try {
      const { isError, errors } = ChangePasswordValidate(passwords);
      setErrors(errors);
      if (isError) return;

      let currentPass = Buffer.from(passwords?.currentPassword).toString("base64");
      let newPass = Buffer.from(passwords?.newPassword).toString("base64");
      let confirmPass = Buffer.from(passwords?.confirmPassword).toString("base64");
      setLoading(true);

      const payload = {
        oldPassword: currentPass,
        newPassword: newPass,
        confirmPassword: confirmPass,
      };

      const response = await updateData(CHANGE_PASSWORD, userData?.id, payload);

      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: response?.message,
      });

      setPasswords({});

      setTimeout(() => logout(), 1000);
      setErrors({});
    } catch (error: any) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AppBreadcrumb
        currentMenu="Change Password"
        pageName="Change Password"
        pageTitle={
          <>
            <Link to={"/dashboard"}>
              <i className="mr-2 pi pi-arrow-left"></i>
            </Link>
            Update Your Password
          </>
        }
      />

      <Toast ref={toast} />

      <div className="w-full p-4 surface-card shadow-2 border-round-lg" style={{ height: "calc(100% - 52px)" }}>
        <h2 className="mb-4 text-2xl font-semibold ">Change Password</h2>

        {/* Current Password */}
        <div className="mb-3 field change_pass">
          <label className="block mb-2 font-medium">Current Password</label>
          <Password
            toggleMask
            feedback={false}
            value={passwords.currentPassword}
            onChange={(e) => onInputChange(e, "currentPassword")}
            placeholder="Enter current password"
            className={errors["currentPassword"] && "p-invalid"}
          />
          <small className="p-invalid-txt">{errors["currentPassword"]}</small>
        </div>

        {/* New Password */}
        <div className="mb-3 field change_pass">
          <label className="block mb-2 font-medium">New Password</label>
          <Password
            toggleMask
            feedback={false}
            value={passwords.newPassword}
            onChange={(e) => onInputChange(e, "newPassword")}
            placeholder="Enter new password"
            className={errors["newPassword"] && "p-invalid"}
          />
          <small className="p-invalid-txt">{errors["newPassword"]}</small>
        </div>

        {/* Confirm new passord */}
        <div className="mb-4 field change_pass">
          <label className="block mb-2 font-medium">Confirm New Password</label>
          <Password
            toggleMask
            feedback={false}
            value={passwords.confirmPassword}
            onChange={(e) => onInputChange(e, "confirmPassword")}
            placeholder="Confirm new password"
            className={errors["confirmPassword"] && "p-invalid"}
          />
          <small className="p-invalid-txt">{errors["confirmPassword"]}</small>
        </div>

        <div className="flex justify-content-start">
          <Button label="Update Password" icon="pi pi-lock" className="common-primary-button" loading={loading} onClick={handleSubmit} />
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
